import { debounce } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from 'axios';
import { useNavigate, Link } from "react-router-dom";
import { AutoRefundsLogs, selectAllInvoices, selectInvoicesPager, updateInvoicesSearch } from "../redux/slices/publicSlice";
import moment from "moment";
import { formatTime } from "../utils/formatTime";
import { Helmet } from "react-helmet-async";
import { useRef } from "react";
import Loader from "../components/Loader";
import { Modal, Button, Form } from 'react-bootstrap';

// import "../assets/public/css/bootstrap.min.css";

const Logs = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const allInvoices = useSelector(selectAllInvoices);
  const pager = useSelector(selectInvoicesPager);
  const [loading, setloading] = useState(true);
  const searchRef = useRef(null);
  const [search, setSearch] = useState("");
  const [sortType, setSortType] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleModalOpen = (id) => {
    setSelectedId(id);
    setShowModal(true);
  };

  const onSearchChangeHandler = useCallback(
    debounce((searchValue) => {
      if (searchValue === "") {
        dispatch(updateInvoicesSearch(""));
        dispatch(AutoRefundsLogs({ page: 1, sortType, setloading }));
      } else {
        dispatch(updateInvoicesSearch(searchValue));
        dispatch(AutoRefundsLogs({ page: 1, sortType, setloading }));
      }
    }, 250),
    [sortType, setloading]
  );
  

  useEffect(() => {
    setloading(true);
    dispatch(AutoRefundsLogs({ page: 1, sortType, setloading }));
  }, [sortType]);

  useEffect(() => {
    setSearch("");
    dispatch(updateInvoicesSearch(""));
  }, []);
  

  const apiKeyRef = useRef();
  const valueRef = useRef();

  const handleSubmit = async (e) => {
    e.preventDefault();
setIsLoading(true);
    const apiKey = apiKeyRef.current.value;
    let value = valueRef.current.value;

    if (!apiKey) {
      alert("Lütfen bir API key girin.");
      return;
    }

    const isPositiveInteger = /^[0-9]+$/; 

    const isNegativeDecimal = /^-?\d+(\.\d{1,2})?$/; 

    let action = '';
    if (isPositiveInteger.test(value)) {
        action = 'add';
    } else if (isNegativeDecimal.test(value)) {
        action = 'del';
        value = value.substring(1); // Önündeki '-' işaretini kaldır
    } else {
        alert("Lütfen doğru bir değer girin.");
        return;
    }
    
    const url = `https://resell.lightningproxies.net/api/${action}/${selectedId}/${value}`;
    try {
      const response = await axios.post(url, null, {
        headers: { 'x-api-key': apiKey }
      });
      console.log(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error("API isteği sırasında bir hata oluştu:", error);
    }
  }
  
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}/${month}/${day}`;
  };

  return (
    <>
      <Helmet>
        <title>Auto Refunds Logs - LightningProxies</title>
      </Helmet>

      <div class="page-body-wrapper">
        <div class="row text-start">
          <div class="col-12 col-md-7 col-xl-6">
            <div class="header-title">
              <h1>Auto Refund Logs</h1>
              <p>Detailed list of all invoices</p>
            </div>
          </div>
          <div class="col-12 col-md-5 col-xl-6">
            <div class="header-bttn">
              <p>
                Need Support?{" "}
                <a href="https://t.me/lightningproxies">
                  Contact Us <i class="fa fa-angle-right"></i>
                </a>
              </p>
            </div>
          </div>
        </div>
        {loading ? (
          <Loader />
        ) : allInvoices && allInvoices.length === 0 && search.length === 0 ? (
          <div class="row">
            <div class="col-12">
              <div class="dashboard-empty-box mt-15">
                <img src="./assets/images/no-invoice.svg" alt="Empty Image" class="img-fluid d-light" />
                <img src="./assets/images/no-invoice-dark.svg" alt="Empty Image" class="img-fluid d-dark" />
                <p>
                  No Logs{" "}
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div class="row">
            <div class="col-12">
              <div class=" active-plan-table mt-15 invoice-list-table overflow-auto">
                <div class="search-box d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-center">
                </div>
                <table>
                  <tr>
                    <th>INVOICE ID</th>
                    <th>PRICE</th>
                    <th>OLD BALANCE</th>
                    <th>NEW BALANCE</th>
                    <th>OLD GB</th>
                    <th>NEW GB</th>
                    <th>CREATION DATE</th>
                    <th>PLAN</th>
                  </tr>

                  {[...allInvoices].map((invoice, index) => {
                    return (
                      <>
                        <tr>
                          <td>{invoice._id}</td>
                          <td className="text-nowrap"><span class="bg-opacity-10 text-nowrap" style={{ backgroundColor: invoice.refund.includes("-") ? "#ff000033" : invoice.refund.includes("+") ? "#00800024" : "black"}}>
                            {invoice.refund.includes("-") && <i className="fa fa-circle text-danger"></i>}
                            {invoice.refund.includes("+") && <i className="fa fa-circle text-success"></i>}
                            {parseFloat(invoice.refund).toFixed(2)}$</span></td>
                          <td>{parseFloat(invoice.oldbalance).toFixed(2)}$</td>
                          <td>{parseFloat(invoice.newbalance).toFixed(2)}$</td>
                          <td>{invoice.oldgb}GB</td>
                          <td>{invoice.newgb}GB</td>
                          <td>{formatDate(invoice.createdAt)}</td>
                          <td>{invoice.plan}</td>
                        </tr>
                      </>
                    );
                  })}
                </table>

                <Modal centered keyboard={false} show={showModal} onHide={handleModalClose} className="edit-modal">
      <Modal.Header closeButton>
          <Modal.Title className="fs-5">{selectedId}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="m-4 text-center fs-6">
          <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                  <Form.Control ref={apiKeyRef} type="text" placeholder="API KEY" />
              </Form.Group>
              <Form.Group className="mb-3">
                  <Form.Control ref={valueRef} type="text" placeholder="GB value" />
              </Form.Group>
              <Modal.Footer className="border-0">
                  <div className="d-flex w-100 align-items-center justify-content-center">
                      <Button variant="primary" type="submit">
                          Submit
                      </Button>
                  </div>
              </Modal.Footer>
          </Form>
      </Modal.Body>
    </Modal>

                {pager?.total > 1 && (
                  <div
                    className="container"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: 20,
                      border: "solid",
                      borderWidth: "0px",
                      borderTopWidth: "0.1px",
                      borderColor: "var(--bs-gray-300)",
                    }}
                  >
                    <nav>
                      <ul class="pagination" style={{ margin: 0 }}>
                        <li
                          class="page-item"
                          style={{
                            margin: "0px",
                            // border: "solid",
                            paddingTop: "2px",
                            // borderWidth: "0.2px",
                            borderColor: "var(--bs-gray-400)",
                            borderTopLeftRadius: 6,
                            borderBottomLeftRadius: 6,
                          }}
                          onClick={() => {
                            dispatch(
                              AutoRefundsLogs({
                                page: pager.page <= 1 ? 1 : pager.page - 1,
                              })
                            );
                          }}
                        >
                          <a class="page-link  bg-transparent" href="#" aria-label="Previous">
                            <span aria-hidden="true" style={{ fontSize: "1.3rem" }}>
                              &laquo;
                            </span>
                          </a>
                        </li>

                        <li
                          class="page-item"
                          style={{
                            padding: 15,
                            display: "flex",
                            alignItems: "center",
                            margin: "0px",
                            // border: "solid",
                            // borderWidth: "0px",
                            // borderBottomWidth: "0.2px",
                            // borderTopWidth: "0.2px",
                            borderColor: "var(--bs-gray-400)",
                          }}
                        >
                          {pager?.page} of {pager?.total}
                        </li>

                        <li
                          class="page-item"
                          style={{
                            margin: "0px",
                            // border: "solid",
                            paddingTop: "2px",
                            // borderWidth: "0.2px",
                            borderColor: "var(--bs-gray-400)",
                            borderTopRightRadius: 6,
                            borderBottomRightRadius: 6,
                          }}
                          onClick={() => {
                            dispatch(
                              AutoRefundsLogs({
                                page: pager.page >= pager.total ? pager.total : pager.page + 1,
                              })
                            );
                          }}
                        >
                          <a class="page-link bg-transparent" href="#" aria-label="Next">
                            <span aria-hidden="true" style={{ fontSize: "1.3rem" }}>
                              &raquo;
                            </span>
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Logs;
